export const blockIconsBusinessandpaymentsWalletNew = (
	<span className='material-symbols-outlined'>wallet</span>
);
